/*
 *   Copyright (c) 2021 vlinder Inc.
 *   All rights reserved.
 *   This software is proprietary of vlinder Inc. and can not be distributed / used for any purpose outside of vlinder Inc. without explicit written consent from the copyright owner.
 */
import styled from 'styled-components';
import { Nav, Navbar } from 'react-bootstrap';

export const BrandNavBar = styled(Navbar)`
  background-color: ${(props) => props.backgroundColor};
`;

export const BrandHeader = styled(Nav)`
  justify-content: center;
  display: flex;
  width: 100%;
  background-color: ${(props) => props.backgroundColor};
`;
